/** ホームの「検討する」。 ゲームを選ぶと、 その盤だけの検討を初期局面から始める。 */
import { useState } from 'react';
import { gameIconSlug, gameLabel } from '../lib/game-meta';
import { navigate } from '../lib/navigate';
import { STUDY_GAMES } from '../lib/study/units';
import '../routes/study.css';
import { createStudy } from '../state/study';
import { ensureWasm, type GameId, getEngine } from '../wasm';
import { HomeMenuIcon } from './HomeMenuIcon';

export function NewStudyButton() {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const start = async (game: GameId) => {
    setBusy(true);
    setError(null);
    try {
      await ensureWasm();
      const id = await createStudy({
        title: gameLabel(game),
        host_seat: null,
        outcome: null,
        players: [],
        creator_seat: null,
        boards: [{ board: 0, game_id: game, result: null, final_state: getEngine(game).init(), first_seat: null, moves: [] }],
      });
      navigate(`/study/${id}/0`);
    } catch (e) {
      setError(e instanceof Error ? e.message : '検討を作れませんでした');
      setBusy(false);
    }
  };
  return (
    <>
      <button className="btn-link home-row" onClick={() => setOpen(true)} data-testid="new-study">
        <HomeMenuIcon name="study" />
        <span className="home-row-label">検討する</span>
      </button>
      {open && (
        <>
          <button className="st-scrim" aria-label="閉じる" onClick={() => setOpen(false)} />
          <div className="st-sheet" role="dialog" aria-label="検討するゲーム">
            <div className="st-sheet-head"><b>検討するゲーム</b></div>
            <ul className="st-games">
              {STUDY_GAMES.map((game) => (
                <li key={game}>
                  <button disabled={busy} onClick={() => void start(game)} data-testid={`new-study-${game}`}>
                    <img src={`/icons/games/${gameIconSlug(game)}.svg`} width={40} height={40} alt="" />
                    <span>{gameLabel(game)}</span>
                  </button>
                </li>
              ))}
            </ul>
            {error && <p className="error">{error}</p>}
          </div>
        </>
      )}
    </>
  );
}
